import * as React from 'react'
import PropTypes from 'prop-types'
import PreviewCompatibleImage from 'src/components/PreviewCompatibleImage'

import * as style from './style.module.css'

export default function Benefit({
  title,
  image,
  description,
}) {
  return (
    <div className={style.benefit}>
      {image && (
        <PreviewCompatibleImage
          imageInfo={{
            image: image.publicURL,
            className: style.icon,
          }}
        />
      )}
      <h4>{title}</h4>
      <p className={style.description}>{description}</p>
    </div>
  )
}

Benefit.defaultProps = {
  title: '',
  description: '',
  image: {
    image: '',
  },
}

export const BenefitType = {
  title: PropTypes.string,
  image: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  description: PropTypes.string,
}

Benefit.propTypes = PropTypes.shape(BenefitType).isRequired
